const lang = window.navigator.language ?? 'EN-us'; // We need the user locale to format time (12h/24h)

import { addMinutes, format, formatDuration as formatDur, intervalToDuration } from 'date-fns';
/**
 * We want to format times in 12h or 24h format based on the locale of the browser. We cannot use date-fns for that, else we have to include all locales in the bundle.
 * Note that intlFormat from date-fns does not support `dateStyle` and `timeStyle` options, so we are using Intl.DateTimeFormat directly
 */
export const formatTime = (date, options: Intl.DateTimeFormatOptions = { timeStyle: 'short' }) =>
  new Intl.DateTimeFormat(lang, options).format(date);

export const formatDuration = (start: Date, end: Date) => {
  const shortEnLocale = { formatDistance: (_, count: number) => count.toString().padStart(2, '0') };

  const duration = intervalToDuration({ start, end });
  return formatDur(duration, {
    delimiter: ':',
    format: ['hours', 'minutes', 'seconds'],
    locale: shortEnLocale,
    zero: true,
  });
};

export const is24HourClock = !new Intl.DateTimeFormat(lang, { timeStyle: 'short' })
  .format(new Date('1970-01-01T14:00'))
  .includes('M');

export const dateTimeFieldFormat = `d MMM yyyy ${is24HourClock ? 'HH:mm' : 'p'}`;

export const formatAsUTC = (date: Date) => {
  const userOffset = date.getTimezoneOffset();
  return addMinutes(date, -userOffset);
};
export const asUTCString = (date?: Date): string | undefined => (date ? formatAsUTC(date).toISOString() : date);

export const asZonelessString = (date?: Date): string | undefined =>
  date ? format(date, "uuuu-MM-dd'T'HH:mm:ss.SSSSSSSSS") : date;

export const formatDateTime = (date: Date) => `${format(date, 'd MMM yyy')}, ${formatTime(date)}`;
